import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ServiceType } from 'src/app/models/service-type';
import { UnitType } from 'src/app/models/unit-type';
import { UnitTypeService } from 'src/app/models/unit-type-service';
import { ServiceService } from 'src/app/services/service.service';
import { UnitTypeService as UnitTypeServiceServ } from 'src/app/services/unit-type.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {

  service_types:ServiceType[]= [];
  service_type:ServiceType = new ServiceType();

  unit_types:UnitType[] = [];
  unit_type:UnitType = new UnitType();

  unit_type_services:UnitTypeService[] = [];
  unit_type_service:UnitTypeService = new UnitTypeService();

  loading:boolean = false;

  constructor(private modalService: NgbModal, private serviceServ:ServiceService, private unitServ:UnitTypeServiceServ, private toastr:ToastrManager) { }

  ngOnInit() {
    this.loading = true;

    this.serviceServ.getServiceTypes().subscribe(service_types=>{
      this.service_types = service_types;
      this.loading = false;
    },error => {
      this.toastr.errorToastr("No se pudo recuperar los tipos de servicio.");
      this.loading = false;
    });

    this.unitServ.getTypes().then(unitTypes => {
      this.unit_types = unitTypes;
      this.loading = false;
    },error => {
      this.toastr.errorToastr("No se pudo recuperar los tipos de unidades.");
      this.loading = false;
    });
  }

  getUnitTypeServices(unit_type:UnitType){
    this.loading = true;
    this.unit_type = unit_type;
    this.unit_type_services = [];
    this.serviceServ.getUnitTypeServices(this.unit_type).subscribe(unit_type_services => {
      this.unit_type_services = unit_type_services;
      this.loading = false;
    },error => {
      this.toastr.errorToastr(error.error.message);
      this.loading = false;
    });
  }

  serviceTypeModal(modal, service_type:ServiceType = null) {
    this.service_type = (service_type)?service_type:new ServiceType();
    this.modalService.open(modal, { size: 'lg', centered: true });
  }

  storeServiceTypeAdd(){
    this.loading = true;
    this.serviceServ.storeServiceTypeAdd(this.service_type).subscribe(service_type => {
      this.service_types.push(service_type);
      this.loading = false;
    },error => {
      this.toastr.errorToastr(error.error.message);
      this.loading = false;
    });
  }

  updateServiceType(){
    this.loading = true;
    let data = {
      description: this.service_type.description
    };
    this.serviceServ.updateServiceType(this.service_type, data).subscribe(service_type => {
      this.service_types.map(service => (service.id == service_type.id)?service_type:service );
      this.loading = false;
    },error => {
      this.toastr.errorToastr(error.error.message);
      this.loading = false;
    });
  }

  unitTypeServiceModal(modal){
    this.unit_type_service.unit_type_id = this.unit_type.id;
    this.unit_type_service.unit_type = this.unit_type;
    this.modalService.open(modal, { size: 'lg', centered: true });
  }

  storeUnitTypeService(){
    this.loading = true;
    this.serviceServ.storeUnitTypeService(this.unit_type_service).subscribe(unit_type_service => {
      this.unit_type_services.push(unit_type_service);
      this.loading = false;
    },error => {
      this.toastr.errorToastr(error.error.message);
      this.loading = false;
    });
  }

}
